import styled from 'styled-components'
import PropTypes from 'prop-types'
import { MdClose } from 'react-icons/md'
import AnimatedModal from './animations/animated-modal'
import Wrapper from './wrapper'
import { Typography } from './typography'
import { OutlineButton, SecondaryButton, TransparentButton } from './button'

const ConfirmationModalStyled = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  .confirmation-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  .confirmation-description {
    margin-block-start: 16px;
    margin-block-end: 24px;
  }
  .confirmation-container {
    background: var(--neutral90);
    padding: 16px;
    border-radius: 8px;
  }
  .confirmation-btns {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
  @media (min-width: 768px) {
    .confirmation-container {
      padding: 40px;
    }
  }
`

function ConfirmationModal({
  visible, title, description, onConfirm, onCancel, cta,
}) {
  return (
    <AnimatedModal show={visible}>
      <Wrapper maxWidth={588}>
        <ConfirmationModalStyled>
          <div className="confirmation-container">
            <div className="confirmation-title-container">
              <Typography small="headline6" large="headline5" color="var(--neutral10)">
                {title}
              </Typography>
              <TransparentButton onClick={onCancel}>
                <MdClose color="white" size="24" />
              </TransparentButton>
            </div>
            <Typography font="regular" className="confirmation-description">{description}</Typography>
            <div className="confirmation-btns">
              <OutlineButton onClick={onCancel}>
                Cancelar
              </OutlineButton>
              <SecondaryButton onClick={onConfirm}>
                {cta}
              </SecondaryButton>
            </div>
          </div>
        </ConfirmationModalStyled>
      </Wrapper>
    </AnimatedModal>
  )
}

ConfirmationModal.defaultProps = {
  visible: false,
}

ConfirmationModal.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cta: PropTypes.string.isRequired,
}

export default ConfirmationModal
